import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { CollectionPaths } from '@models/collections';
import { FirestoreStateBaseForBusinessWithSubscription } from '@state/FirestoreStateBaseForBusiness';
import {
	CloserTask,
	CloserTaskName,
	CloserTasksModel,
	CloserToLeapClientSyncTask,
} from './closerTasks.model';
import { Logger } from '@core/logger';

//type Ctx = StateContext<CloserTasksModel>;

const DEFAULT_STATE: CloserTasksModel = {
	closerTasks: [],
};

@State<CloserTasksModel>({
	name: 'closerTasks',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class CloserTasksState extends FirestoreStateBaseForBusinessWithSubscription<
	CloserTask,
	CloserTasksModel
> {
	constructor() {
		super(
			(pathParams) =>
				CollectionPaths.business_closerTasks(pathParams.businessId),
			(doc) => ({ closerTasks: doc as CloserTask[] }),
			() => DEFAULT_STATE,
		);
	}

	@Selector([CloserTasksState])
	static getAll(state: CloserTasksModel): CloserTask[] {
		Logger.info(`CloserTasksState updated: ${JSON.stringify(state)}`);

		return state?.closerTasks ?? [];
	}

	@Selector([CloserTasksState.getAll])
	static closerToLeapClientSyncTask(
		closerTasks: CloserTask[] | null,
	): CloserToLeapClientSyncTask {
		Logger.info(
			`Updating closerToLeapClientSyncTask: ${JSON.stringify(closerTasks)}`,
		);

		const matchedTask = closerTasks.find(
			(task) => task.id === CloserTaskName.CloserToLeapClientSync,
		) as CloserToLeapClientSyncTask;

		return matchedTask ?? null;
	}
}
